import {
  IconDefinition,
  IconFamily,
} from '@fortawesome/fontawesome-common-types';
import styledIcon, { IconStyles } from './styledIcon';

export const faCircleUser = circleUser('classic', 'thin');
export const falCircleUser = circleUser('classic', 'light');
export const fatCircleUser = circleUser('classic', 'thin');
export const fadCircleUser = circleUser('duotone', 'thin');
export const fasCircleUser = circleUser('classic', 'solid');
export const farCircleUser = circleUser('classic', 'regular');

export default function circleUser(
  family: IconFamily,
  style: IconStyles
): IconDefinition {
  return styledIcon(
    family,
    style,
    'circle-user',
    512, // width
    512, // height
    'f2bd', // unicode
    [
      [
        'classic',
        'solid',
        'M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z',
      ],
      [
        'classic',
        'regular',
        'M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z',
      ],
      [
        'classic',
        'light',
        'M412.1 416.6C398.1 361.1 347.9 320 288 320l-64 0c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1l64 0c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z',
      ],
      [
        'classic',
        'thin',
        'M256 496c-54 0-103.9-17.9-144-48c0 0 0 0 0 0c0-61.9 50.1-112 112-112l64 0c61.9 0 112 50.1 112 112c0 0 0 0 0 0c5.3-4 10.4-8.2 15.4-12.6C409.1 370.6 354.5 320 288 320l-64 0c-66.5 0-121.1 50.6-127.4 115.4C47.2 391.5 16 327.4 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240s-107.5 240-240 240zm0 16A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-304a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
      ],
      [
        'duotone',
        'thin',
        [
          'M16 256c0 71.4 31.2 135.5 80.6 179.4C102.9 370.6 157.5 320 224 320l64 0c66.5 0 121.1 50.6 127.4 115.4c-2.5 2.2-5 4.3-7.5 6.4C461.6 397.9 496 330.9 496 256C496 123.5 388.5 16 256 16S16 123.5 16 256zm320-48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z',
          'M256 496c-54 0-103.9-17.9-144-48c0 0 0 0 0 0c0-61.9 50.1-112 112-112l64 0c61.9 0 112 50.1 112 112c0 0 0 0 0 0c5.3-4 10.4-8.2 15.4-12.6C409.1 370.6 354.5 320 288 320l-64 0c-66.5 0-121.1 50.6-127.4 115.4C47.2 391.5 16 327.4 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240s-107.5 240-240 240zm0 16A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-304a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z',
        ],
      ],
    ]
  );
}
